import { useCallback, useState, useEffect } from "react";
// import { TextField, InputAdornment, Icon, IconButton } from "@mui/material";
import {
  TextField,
  InputAdornment,
  Icon,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import PropTypes from "prop-types";
import styles from "./NewUsers.module.css";
import config from "../../../config/config";
import axios from "axios";
import store from "../../../Store/Store";
import companyStore from "../../../Store/Store";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { useDebouncedLog } from "../../../useDebouncedLog";
import { observer } from "mobx-react";

const NewUsers = observer(
  ({
    isVisible,
    onClose,
    openNoti,
    resetAdmin,
    setAdmin,
    setViewAdmin,
    setUserAccess,
    className = "",
  }) => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [Txnlimt, setTxnlimt] = useState("");
    const [dailyLimit, setDailyLimit] = useState("");
    const [MonthlyLimit, setMonthlyLimit] = useState("");
    const [isAdmin, setIsAdmin] = useState(false);
    const [isViewAdmin, setIsViewAdmin] = useState(false);
    const [isUser, setIsUser] = useState(false);
    const [tags, setTags] = useState("");
    const [EmpInfo, setEmpInfo] = useState({
      EmpCode: "",
      location: "",
      Department: "",
    });
    const [AllTags, setAllTags] = useState([]);

    const [PhoneNo, setPhoneNo] = useState("");
    const [ErrorMessage, setErrorMessage] = useState("");
    const [errormsg, setErrorMsg] = useState({
      isNameTooShort: false,
      isAnyFieldEmpty: false,
      isInvalidEmail: false,
      isInvalidNumber: false,
      isTxnLimitNegative: false,
      isDailyLimitNegative: false,
      isMonthlyLimitNegative: false,
      isNumberTooShort: false,
      isTxnLimitExceeds: false,
      isDailyLimitExceedsMonthly: false,
      isUserExists: false,
      invalidName: false,
    });
    function parseEmpDetails(str) {
      if (!str || typeof str !== "string") {
        return { Empcode: "", location: "", Department: "" };
      }

      const result = { Empcode: "", location: "", Department: "" };

      // Split by comma
      const pairs = str.split(",");

      for (const pair of pairs) {
        const [key, value] = pair.split(":");

        if (key && value !== undefined) {
          const trimmedKey = key.trim();
          const trimmedValue = value.trim();

          if (trimmedKey === "Empcode") {
            result.Empcode = trimmedValue;
          } else if (trimmedKey === "location") {
            result.location = trimmedValue;
          } else if (trimmedKey === "Department") {
            result.Department = trimmedValue;
          }
        }
      }

      return result;
    }
    useEffect(() => {
      console.log("companyStore.TagsEmpDetails", companyStore.TagsEmpDetails);
      if (companyStore.TagsEmpDetails) {
        let value = parseEmpDetails(companyStore.TagsEmpDetails);
        console.log("value----->>>>>", value);
        if (value.Empcode) {
          setEmpInfo((prev) => ({ ...prev, EmpCode: value.Empcode }));
        } else {
          setEmpInfo((prev) => ({ ...prev, EmpCode: "" }));
        }
        if (value.location) {
          setEmpInfo((prev) => ({ ...prev, location: value.location }));
        } else {
          setEmpInfo((prev) => ({ ...prev, location: "" }));
        }
        if (value.Department) {
          setEmpInfo((prev) => ({ ...prev, Department: value.Department }));
        } else {
          setEmpInfo((prev) => ({ ...prev, Department: "" }));
        }
      } else {
        setEmpInfo({ EmpCode: "", location: "", Department: "" });
      }
    }, [store.showEmpDetails]);

    var logAddNewUserVisited;
    var logPineAddNewUser;
    var logAxisAddNewUser;
    try {
      logAddNewUserVisited = useDebouncedLog("admin_add_new_user_visited", 500);
      logAxisAddNewUser = useDebouncedLog("admin_add_axis_new_user", 500);
      logPineAddNewUser = useDebouncedLog("admin_add_pine_new_user", 500);
    } catch (err) {
      console.log("error", err);
    }
    useEffect(() => {
      logAddNewUserVisited();
    }, [logAddNewUserVisited]);

    const isTokenExpired = (token) => {
      try {
        const decoded = jwtDecode(token);

        if (decoded && decoded.exp) {
          const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
          return decoded.exp < currentTime;
        }
      } catch (error) {
        console.log("Error decoding token:", error);
        return true; // Treat decoding failures as expired tokens
      }
      return true;
    };

    const getNewTokens = async (authData) => {
      if (!authData?.RefreshToken) {
        localStorage.removeItem("authToken");
        navigate("/login");
        return;
      }

      try {
        const client = new CognitoIdentityProviderClient({
          region: "ap-south-1",
        });

        const params = {
          ClientId: config.Client_Id,
          AuthFlow: "REFRESH_TOKEN_AUTH",
          AuthParameters: {
            REFRESH_TOKEN: authData?.RefreshToken,
          },
        };

        const command = new InitiateAuthCommand(params);
        const refreshResponse = await client.send(command);

        if (refreshResponse.AuthenticationResult) {
          const newAuthToken = {
            AccessToken: refreshResponse.AuthenticationResult.AccessToken,
            RefreshToken: authData?.RefreshToken, // Keep old refresh token
            IdToken: refreshResponse.AuthenticationResult.IdToken,
          };

          localStorage.setItem("authToken", JSON.stringify(newAuthToken));
          if (store.refresh) {
            store.setRefresh(false);
          } else {
            store.setRefresh(true);
          }
        } else {
          localStorage.removeItem("authToken");
          navigate("/login");
        }
      } catch (error) {
        console.log("Error refreshing tokens:", error);
        localStorage.removeItem("authToken");
        navigate("/login");
      }
    };

    function stringToJson(input) {
      const pairs = input.split(",");
      const result = {};

      for (const pair of pairs) {
        const [key, value] = pair.split(":");
        if (key && value) {
          result[key.trim()] = value.trim();
        }
      }

      return JSON.stringify(result, null, 2);
    }

    const onFrameButtonClick = () => {
      resetAdmin();
      console.log("button clicked");
      console.log("isAdmin", isAdmin);
      console.log("isViewAdmin", isViewAdmin);
      console.log("isUser", isUser);
      setErrorMsg({
        isNameTooShort: false,
        isAnyFieldEmpty: false,
        isInvalidEmail: false,
        isTxnLimitNegative: false,
        isInvalidNumber: false,
        isNumberTooShort: false,
        isDailyLimitNegative: false,
        isMonthlyLimitNegative: false,
        isTxnLimitExceeds: false,
        isDailyLimitExceedsMonthly: false,
        isUserExists: false,
        NoRolesAssigned: false,
        invalidName: false,
      });
      if (name == "" || PhoneNo == "") {
        setErrorMsg((prev) => ({ ...prev, isAnyFieldEmpty: true }));
        setErrorMessage("Field is required");
        return;
      }
      if (
        (Txnlimt == "" || dailyLimit == "" || MonthlyLimit == "") &&
        (isUser || !store.isUserOwner)
      ) {
        setErrorMsg((prev) => ({ ...prev, isAnyFieldEmpty: true }));
        setErrorMessage("Field is required");
        return;
      }
      if (name.trim().length < 3) {
        setErrorMessage("Name Cannot be less that 3 character");
        setErrorMsg((prev) => ({ ...prev, isNameTooShort: true }));
        return;
      }
      const nameRegex = /^[a-zA-Z\s]+$/;
      if (!nameRegex.test(name)) {
        setErrorMessage("Please enter a valid name");
        console.log("name", name);

        setErrorMsg((prev) => ({ ...prev, invalidName: true }));
        return;
      }
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(email) && email !== "") {
        setErrorMsg((prev) => ({ ...prev, isInvalidEmail: true }));
        setErrorMessage("Please enter a valid email address");
        return;
      }
      const phonenumberregex = /^\d{10}$|^[\d\s.-]{10}$/;
      if (!phonenumberregex.test(PhoneNo)) {
        setErrorMsg((prev) => ({ ...prev, isInvalidNumber: true }));
        setErrorMessage("Please enter a valid phone number");
        return;
      }
      if (
        PhoneNo[0] != "6" &&
        PhoneNo[0] != "7" &&
        PhoneNo[0] != "8" &&
        PhoneNo[0] != "9"
      ) {
        setErrorMsg((prev) => ({ ...prev, isInvalidNumber: true }));
        setErrorMessage("Please enter a valid phone number");
        return;
      }
      if (!store.isUserOwner) {
        console.log(
          "you are not a owner------------------------------------------",
        );

        setIsUser(true);
      }
      if (
        (Number(dailyLimit) <= 0 ||
          Number(Txnlimt) <= 0 ||
          Number(MonthlyLimit) <= 0) &&
        (isUser || !store.isUserOwner)
      ) {
        if (Number(dailyLimit) <= 0) {
          setErrorMsg((prev) => ({ ...prev, isDailyLimitNegative: true }));
        }
        if (Number(Txnlimt) <= 0) {
          setErrorMsg((prev) => ({ ...prev, isTxnLimitNegative: true }));
        }
        if (Number(MonthlyLimit) <= 0) {
          setErrorMsg((prev) => ({ ...prev, isMonthlyLimitNegative: true }));
        }
        setErrorMessage("Limits Cannot be 0");
        return;
      }
      if (
        (Number(Txnlimt) > Number(dailyLimit) ||
          Number(Txnlimt) > Number(MonthlyLimit)) &&
        (isUser || !store.isUserOwner)
      ) {
        setErrorMsg((prev) => ({ ...prev, isTxnLimitExceeds: true }));
        setErrorMessage(
          "Transaction Limit should not be greater than dailyLimit or monthlyLimit",
        );
        return;
      }
      if (
        Number(dailyLimit) > Number(MonthlyLimit) &&
        (isUser || !store.isUserOwner)
      ) {
        setErrorMsg((prev) => ({ ...prev, isDailyLimitExceedsMonthly: true }));
        setErrorMessage("Daily Limit should not be greater than monthlyLimit");
        return;
      }
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }

      const UserMobileNumber =
        companyStore.userType != "PineLabUser" ? `+91${PhoneNo}` : PhoneNo;
      const newroles = [];
      if (isAdmin) {
        newroles.push("ADMIN");
        setAdmin();
      }
      if (isUser) {
        setUserAccess();
        newroles.push("CUPI_COMPANY_EMPLOYEE");
      }
      if (!store.isUserOwner) {
        newroles.push("CUPI_COMPANY_EMPLOYEE");
      }
      if (isViewAdmin) {
        setViewAdmin();
        newroles.push("CUPI_VIEW_ADMIN");
      }
      let employee_info = {};
      let Finaltags = AllTags.join(", ");
      if (companyStore.TagsEmpDetails) {
        let teststring = stringToJson(companyStore.TagsEmpDetails);
        teststring = JSON.parse(teststring);
        if (teststring.Empcode) {
          employee_info.employee_code = teststring.Empcode;
        }
        if (teststring.location) {
          employee_info.employee_location = teststring.location;
        }
        if (teststring.Department) {
          employee_info.employee_department = teststring.Department;
        }
      }
      if (store.isUserOwner && newroles.length == 0) {
        console.log("init");
        setErrorMsg((prev) => ({ ...prev, NoRolesAssigned: true }));
        setErrorMessage("Please Assign a Role");
        return;
      }
      let obj1;
      if (companyStore.userType != "PineLabUser") {
        try {
          logAxisAddNewUser();
        } catch (er) {
          console.log("error%o", er);
        }

        if (email) {
          obj1 = JSON.stringify({
            user_name: UserMobileNumber,
            user_full_name: name.trim(),
            user_email: email.trim(),
            user_mobile_no: UserMobileNumber,
            perTxnLimit: Number(Txnlimt),
            dailyLimit: Number(dailyLimit),
            monthlyLimit: Number(MonthlyLimit),
            ledger_label: store.Company_Id,
            roles: newroles,
            tags: Finaltags,
          });
        } else {
          obj1 = JSON.stringify({
            user_name: UserMobileNumber,
            user_full_name: name.trim(),
            user_mobile_no: UserMobileNumber,
            perTxnLimit: Number(Txnlimt),
            dailyLimit: Number(dailyLimit),
            monthlyLimit: Number(MonthlyLimit),
            ledger_label: store.Company_Id,
            roles: newroles,
            tags: Finaltags,
          });
        }
      } else {
        try {
          logPineAddNewUser();
        } catch (er) {
          console.log("error%o", er);
        }
        if (email) {
          obj1 = JSON.stringify({
            user_name: name.trim(),
            user_email: email.trim(),
            user_mobile_no: UserMobileNumber,
            perTxnLimit: Number(Txnlimt),
            dailyLimit: Number(dailyLimit),
            monthlyLimit: Number(MonthlyLimit),
            ledger_label: store.Company_Id,
            roles: newroles,
            tags: Finaltags,
          });
        } else {
          obj1 = JSON.stringify({
            user_name: name.trim(),
            user_mobile_no: UserMobileNumber,
            perTxnLimit: Number(Txnlimt),
            dailyLimit: Number(dailyLimit),
            monthlyLimit: Number(MonthlyLimit),
            ledger_label: store.Company_Id,
            roles: newroles,
            tags: Finaltags,
          });
        }
      }
      obj1 = JSON.parse(obj1);
      if (
        employee_info &&
        (employee_info.employee_code ||
          employee_info.employee_location ||
          employee_info.employee_department)
      ) {
        obj1.employee_info = employee_info;
      }
      console.log("obj1",obj1);
      obj1 = JSON.stringify(obj1);

      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url:
          store.userType == "PineLabUser"
            ? `${config.node_api_endpoint}/cupi/admin/pine/create_cupi_compnay_user`
            : `${config.node_api_endpoint}/cupi/admin/create_cupi_compnay_user`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: obj1,
      };
      try {
        console.log("axios call");

        axios
          .request(payload)
          .then((res) => {
            console.log("success");
            let userExist;
            if (res.data.data) {
              userExist =
                res?.data?.data?.message == "User Already Exists :" ||
                res?.data?.data == "User KYC is pending";
            }
            try {
              console.log("went through", userExist);

              if (userExist) {
                console.log("UserExist");
                store.refresh
                  ? store.setRefresh(false)
                  : store.setRefresh(true);
                setErrorMsg((prev) => ({ ...prev, isUserExists: true }));
                setErrorMessage("User Already Exists");
                return;
              }
              console.log("res", res.data);
              if (
                res.data.data.message ==
                "KYC Completed, Wallet Creation Initiated"
              ) {
                // store.setInitiateKYC("AddedToUserList");
                store.setInitiateKYC("AddedToPendingList");
              }
              console.log("adding new user");
              onClose();
              openNoti();
              store.refresh ? store.setRefresh(false) : store.setRefresh(true);
            } catch (er) {
              console.log("error", er);
            }
          })
          .catch((err) => {
            console.log("erro %o", err);
            setErrorMsg((prev) => ({ ...prev, isUserExists: true }));
            setErrorMessage(
              "We couldn’t add this user. Please try again. If the issue persists, contact CUPI Support",
            );
            if (
              err?.response?.data?.data ==
                "User already Exists for this company, Update the User instead of creatating a new one" ||
              err?.response?.data?.data?.message?.trim() ==
                "User KYC is pending" ||
              err?.response?.data?.data?.data?.data?.message?.trim() ==
                "User already Exists for this company, Update the User instead of creatating a new one"
            ) {
              console.log("UserExist");
              store.refresh ? store.setRefresh(false) : store.setRefresh(true);
              setErrorMsg((prev) => ({ ...prev, isUserExists: true }));
              setErrorMessage("User Already Exists");
              return;
            }
          });
        store.refresh ? store.setRefresh(false) : store.setRefresh(true);
      } catch (err) {
        console.log("error %o", err);
      } finally {
        companyStore.setEmpDetails("");
        setEmpInfo({ EmpCode: "", location: "", Department: "" });
      }
    };

    const handlenewTags = async () => {
      if (tags.trim() == "") {
        setTags("");
        return;
      }
      tags.split(",").map((data) => {
        AllTags.unshift(data);
      });
      setTags("");
      console.log("ALLTAGS", AllTags);
    };

    const removeTag = (data, index) => {
      setAllTags((prevTags) => {
        const newTags = [...prevTags];
        newTags.splice(index, 1);
        return newTags;
      });
    };

    if (!isVisible) return null;
    return (
      <div
        className={[styles.frameParent, className].join(" ")}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className={styles.frameGroup}
          onClick={() => {
            companyStore.setEmpDetails("");
            setEmpInfo({ EmpCode: "", location: "", Department: "" });
            store.refresh ? store.setRefresh(false) : store.setRefresh(true);
            onClose();
          }}
        >
          <img
            className={styles.arrowNarrowLeftIcon}
            alt=""
            src="/xclose.svg"
          />
        </div>
        <div className={styles.frameParent1}>
          {companyStore.userType == "AxisUser" && (
            <div className={styles.addUserDetails}>Add New User</div>
          )}
          {companyStore.userType == "PineLabUser" && (
            <div className={styles.addUserDetails}>New KYC Request</div>
          )}
          <div className={styles.frameWrapper}>
            {companyStore.userType == "PineLabUser" && (
              <div className={styles.mobileMenuParent}>
                <div className={styles.AlertMessage}>
                  <div className={styles.AlertMessageHeading}>
                    <img
                      className={styles.AlertMessageIcon}
                      alt=""
                      src="/exclamation_circle.svg"
                    />
                    To Complete User KYC
                  </div>
                  <div className={styles.AlertMessageText}>
                    <span className={styles.Bold}>Physical PAN</span> must be
                    shown during Video KYC. please ask employees to keep it
                    ready for the call.
                  </div>
                </div>
              </div>
            )}

            <div className={styles.mobileMenuParent}>
              <div>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={name}
                  label={
                    companyStore.userType == "PineLabUser"
                      ? "Name*( as per PAN )"
                      : "Name*"
                  }
                  // required
                  onChange={(e) => {
                    setErrorMessage("");
                    setErrorMsg((prev) => ({
                      ...prev,
                      isAnyFieldEmpty: false,
                      isNameTooShort: false,
                      invalidName: false,
                    }));
                    setName(e.target.value);
                  }}
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: "56px",
                    },
                    width: "100%",
                  }}
                  InputProps={{
                    style: {
                      borderRadius: ".45rem",
                    },
                  }}
                />
                {(errormsg.isNameTooShort ||
                  errormsg.invalidName ||
                  (errormsg.isAnyFieldEmpty && name == "")) && (
                  <div className={styles.errorDiv}>
                    {(errormsg.isNameTooShort || errormsg.invalidName) && (
                      <div className={styles.error}>{ErrorMessage}</div>
                    )}
                    {errormsg.isAnyFieldEmpty && name == "" && (
                      <div className={styles.error}>{ErrorMessage}</div>
                    )}
                  </div>
                )}
              </div>

              <div>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={PhoneNo}
                  label="User Phone no"
                  required
                  type="number"
                  onChange={(e) => {
                    setErrorMessage("");
                    setErrorMsg((prev) => ({
                      ...prev,
                      isAnyFieldEmpty: false,
                      isNumberTooShort: false,
                      isInvalidNumber: false,
                      isUserExists: false,
                    }));
                    const value = e.target.value.replace(/[^0-9]/g, "");
                    if (value.length <= 10) {
                      setPhoneNo(value);
                    }
                  }}
                  variant="outlined"
                  InputProps={{
                    maxBodyLength: 10,
                    style: {
                      borderRadius: ".45rem",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      appearance: "none",
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: "56px",
                    },
                    width: "100%",
                    "& input[type=number]": {
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    },
                  }}
                />
                {(errormsg.isNumberTooShort ||
                  errormsg.isInvalidNumber ||
                  errormsg.isUserExists ||
                  (errormsg.isAnyFieldEmpty && PhoneNo == "")) && (
                  <div className={styles.errorDiv}>
                    {" "}
                    {errormsg.isNumberTooShort && (
                      <div className={styles.error}>{ErrorMessage}</div>
                    )}
                    {(errormsg.isInvalidNumber || errormsg.isUserExists) && (
                      <div className={styles.error}>{ErrorMessage}</div>
                    )}
                    {errormsg.isAnyFieldEmpty && PhoneNo == "" && (
                      <div className={styles.error}>{ErrorMessage}</div>
                    )}
                  </div>
                )}
              </div>

              <div>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={email}
                  type="email"
                  label="User Email ID"
                  variant="outlined"
                  // required
                  InputProps={{
                    style: {
                      borderRadius: ".55rem",
                    },
                  }}
                  onChange={(e) => {
                    setErrorMessage("");
                    setErrorMsg((prev) => ({
                      ...prev,
                      isAnyFieldEmpty: false,
                      isInvalidEmail: false,
                    }));
                    setEmail(e.target.value);
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: "56px",
                    },
                    width: "100%",
                  }}
                />
                {((errormsg.isInvalidEmail && email != "") ||
                  errormsg.isInvalidEmail) && (
                  <div className={styles.errorDiv}>
                    {errormsg.isInvalidEmail && email != "" && (
                      <div className={styles.error}>{ErrorMessage}</div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          {EmpInfo.EmpCode || EmpInfo.location || EmpInfo.Department ? (
            <div className={styles.Empinfo}>
              <div className={styles.Empinfoheading}>
                <div className={styles.containerheading}>Employee Details</div>
                <div
                  className={styles.containerheading1}
                  onClick={() => {
                    companyStore.setShowEmpDetails(true);
                  }}
                >
                  <img
                    className={styles.arrowNarrowLeftIcon122}
                    alt=""
                    src="/edit-02.svg"
                  />
                  Edit
                </div>
              </div>
              <div className={styles.EmpinfoContentContainer}>
                {EmpInfo.EmpCode && (
                  <div className={styles.EmpinfoContent1}>
                    <img
                      className={styles.EmpinfoContenticon1}
                      alt=""
                      src="/user-square.svg"
                    />
                    {EmpInfo.EmpCode.substring(0, 8)}
                  </div>
                )}
                {EmpInfo.location && (
                  <div className={styles.EmpinfoContent1}>
                    <img
                      className={styles.EmpinfoContenticon1}
                      alt=""
                      src="/location.svg"
                    />
                    {EmpInfo.location.substring(0, 8)}
                  </div>
                )}
                {EmpInfo.Department && (
                  <div className={styles.EmpinfoContent1}>
                    <img
                      className={styles.EmpinfoContenticon1}
                      alt=""
                      src="/building-06.svg"
                    />
                    {EmpInfo.Department.substring(0, 8)}
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div className={styles.mobileMenuContainer}>
              <button
                className={styles.invertloadsButtons}
                onClick={() => {
                  companyStore.setShowEmpDetails(true);
                }}
              >
                <img
                  className={styles.arrowNarrowLeftIcon1}
                  alt=""
                  src="/pluscircleBlue.svg"
                />
                <b>Add Employee Details</b>
              </button>
            </div>
          )}
          <div className={styles.mobileMenuContainer}>
            <TextField
              className={styles.mobileMenu32}
              color="primary"
              value={tags}
              type="email"
              label="Tag"
              variant="outlined"
              // required
              InputProps={{
                style: {
                  borderRadius: ".75rem",
                },
              }}
              onChange={(e) => {
                setTags(e.target.value);
              }}
              sx={{
                "& .MuiInputBase-root": { height: "100%", minHeight: "56px" },
                width: "90%",
              }}
            />
            <div
              className={styles.mobileMenuButton}
              onClick={() => {
                handlenewTags();
              }}
            >
              <img
                className={styles.arrowNarrowLeftIcon13}
                alt=""
                src="/pluscircle.svg"
              />
            </div>
          </div>

          <div className={styles.setTransactionTagLimit}>
            {AllTags &&
              AllTags.map((data, index) => {
                return (
                  <div className={styles.setTransactionOneTag}>
                    {data.slice(0, 15)}
                    {data.length > 15 ? "..." : ""}
                    <button
                      className={styles.setTransactionButton}
                      onClick={() => {
                        removeTag(data, index);
                      }}
                    >
                      <img
                        className={styles.arrowNarrowLeftIcon12}
                        alt=""
                        src="/Close.svg"
                      />
                    </button>
                  </div>
                );
              })}
          </div>
          <div className={styles.setTransactionLimitWrapper}>
            <div className={styles.addUserDetails}>Set transaction limit</div>
          </div>
          <div className={styles.frameWrapper1}>
            <div className={styles.mobileMenuParent}>
              <div>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={Txnlimt}
                  type="number"
                  required
                  label="Per transaction limit"
                  onChange={(e) => {
                    setErrorMessage("");
                    setErrorMsg((prev) => ({
                      ...prev,
                      isAnyFieldEmpty: false,
                      isTxnLimitNegative: false,
                      isTxnLimitExceeds: false,
                    }));
                    setTxnlimt(e.target.value);
                  }}
                  onWheel={(e) => e.target.blur()}
                  variant="outlined"
                  InputProps={{
                    style: {
                      borderRadius: ".45rem",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                      appearance: "none",
                    },
                  }}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: "56px",
                    },
                    width: "100%",
                    "& input[type=number]": {
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    },
                  }}
                />
                {(errormsg.isTxnLimitNegative ||
                  errormsg.isTxnLimitExceeds ||
                  (errormsg.isAnyFieldEmpty && Txnlimt == "")) && (
                  <div className={styles.errorDiv}>
                    {(errormsg.isTxnLimitNegative ||
                      errormsg.isTxnLimitExceeds) && (
                      <div className={styles.error}>{ErrorMessage}</div>
                    )}
                    {errormsg.isAnyFieldEmpty && Txnlimt == "" && (
                      <div className={styles.error}>{ErrorMessage}</div>
                    )}
                  </div>
                )}
              </div>
              <div>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={dailyLimit}
                  type="number"
                  required
                  label="Daily limit"
                  variant="outlined"
                  InputProps={{
                    style: {
                      borderRadius: ".45rem",
                      fontSize: "1rem",
                    },
                  }}
                  onChange={(e) => {
                    setErrorMessage("");
                    setDailyLimit(e.target.value);
                  }}
                  onWheel={(e) => e.target.blur()}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: "56px",
                    },
                    width: "100%",
                    "& input[type=number]": {
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    },
                  }}
                />
                {(errormsg.isDailyLimitNegative ||
                  errormsg.isDailyLimitExceedsMonthly ||
                  (errormsg.isAnyFieldEmpty && dailyLimit == "")) && (
                  <div className={styles.errorDiv}>
                    {(errormsg.isDailyLimitNegative ||
                      errormsg.isDailyLimitExceedsMonthly) && (
                      <div className={styles.error}>{ErrorMessage}</div>
                    )}
                    {errormsg.isAnyFieldEmpty && dailyLimit == "" && (
                      <div className={styles.error}>{ErrorMessage}</div>
                    )}
                  </div>
                )}
              </div>

              <div>
                <TextField
                  className={styles.mobileMenu}
                  color="primary"
                  value={MonthlyLimit}
                  type="number"
                  required
                  InputProps={{
                    style: {
                      borderRadius: ".45rem",
                    },
                  }}
                  onChange={(e) => {
                    setErrorMessage("");
                    setMonthlyLimit(e.target.value);
                  }}
                  onWheel={(e) => e.target.blur()}
                  label="Monthly limit"
                  variant="outlined"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: "100%",
                      minHeight: "56px",
                    },
                    width: "100%",
                    "& input[type=number]": {
                      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                    },
                  }}
                />
              </div>
            </div>
            {errormsg.isMonthlyLimitNegative && (
              <div className={styles.error}>{ErrorMessage}</div>
            )}
            {errormsg.isAnyFieldEmpty && MonthlyLimit == "" && (
              <div className={styles.error}>{ErrorMessage}</div>
            )}
          </div>
          {store.isUserOwner && (
            <div className={styles.Toggle}>
              <div className={styles.AdminHeader}>Set Role</div>
              <div className={styles.ToggleContainer}>
                <div className={styles.AdminBtn}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isAdmin}
                          onChange={(event) => {
                            setIsAdmin(event.target.checked);
                            setIsViewAdmin(event.target.checked); //Enable VIEW ADMIN
                          }}
                        />
                      }
                      label="Admin"
                    />
                  </FormGroup>
                </div>

                <div className={styles.MidLine}></div>
                <div className={styles.AdminBtn}>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isUser}
                          onChange={(event) => setIsUser(event.target.checked)}
                        />
                      }
                      label="App User"
                    />
                  </FormGroup>
                </div>
              </div>
            </div>
          )}
          {store.isUserOwner && (
            <div className={isAdmin ? styles.ViewToggleDis : styles.ViewToggle}>
              <div className={styles.ViewToggleHead1}>
                Dashboard viewer
                <Checkbox
                  checked={isViewAdmin || isAdmin}
                  onChange={(event) => {
                    !isAdmin ? setIsViewAdmin(event.target.checked) : null;
                  }}
                />
              </div>
              <div className={styles.ViewToggleBody1}>
                <span className={styles.ViewToggleNote}>Note: </span>Viewers
                only see CUPI Web Dashboard usage
              </div>
            </div>
          )}

          {errormsg.NoRolesAssigned && (
            <div className={styles.error}>{ErrorMessage}</div>
          )}
          {store.isUserOwner &&
            companyStore.userType == "PineLabUser" &&
            isUser && (
              <div className={styles.UpdateLableContainer}>
                <div className={styles.UpdateLable}>
                  To add as an App user, KYC needs to be completed. The KYC link
                  will be sent to the User.
                </div>
              </div>
            )}
          <div
            className={styles.frameDiv}
            onClick={() => {
              onFrameButtonClick();
            }}
          >
            <div className={styles.loadsButtonsWrapper}>
              <div className={styles.loadsButtons}>
                <b className={styles.submit}>Submit</b>
              </div>
            </div>
          </div>
          {companyStore.userType == "PineLabUser" && (
            <div className={styles.finalCupiLogo}>
              <img
                className={styles.escrowLogo}
                alt=""
                src="/PineLabsLogo.svg"
              />
            </div>
          )}
        </div>
      </div>
    );
  },
);

NewUsers.propTypes = {
  className: PropTypes.string,
};

export default NewUsers;
